/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import type { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Invite',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M9.55 10.202a3.3 3.3 0 0 0 0-6.6 3.3 3.3 0 0 0 0 6.6zm4.5-3.3c0 1.574-.808 2.96-2.032 3.764.54.208 1.053.484 1.528.824.3.207.232.64-.068.83l-.112.074a.56.56 0 0 1-.626-.003 5.67 5.67 0 0 0-3.19-.984 5.69 5.69 0 0 0-4.031 1.682c-1.074 1.078-1.687 2.546-1.702 4.084v2.12a.5.5 0 0 0 .5.5h6.19c.214 0 .402.137.483.335l.033.08c.15.357-.095.784-.483.784H3.737c-.297 0-.582-.12-.792-.332a1.14 1.14 0 0 1-.328-.802v-2.7c.016-1.85.753-3.622 2.05-4.925.694-.696 1.518-1.23 2.414-1.575-1.224-.804-2.032-2.2-2.032-3.764a4.5 4.5 0 0 1 9 0zm3.15 6.35a.6.6 0 0 1 .6.6v2.85h2.984a.6.6 0 0 1 0 1.2h-2.984v3.096a.6.6 0 0 1-1.2 0v-3.096h-2.96a.6.6 0 0 1 0-1.2h2.96v-2.85a.6.6 0 0 1 .6-.6z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
